import Errors from './error-codes';
import VASTParserError from './vast-parser-error';

export default class ErrorHandler {
    private _strictMode: boolean;

    constructor(strict: boolean) {
        this._strictMode = strict;
    }

    failWithErrorCode(error: Error, errorCode: number): never {
        if (error instanceof VASTParserError) {
            throw error;
        }
        throw new VASTParserError(
            error instanceof Error ? error.message : String(error),
            errorCode
        );
    }

    fail(error: Error): never {
        this.failWithErrorCode(error, Errors.VAST_SCHEMA_VALIDATION_ERROR);
    }

    tryRecover(error: Error): void {
        if (this._strictMode) {
            this.fail(error);
        }
    }
}
